import { FC, ReactNode } from 'react'
import { createPortal } from 'react-dom'

type PrintRootProps = {
  children: ReactNode
}

export const PrintRoot: FC<PrintRootProps> = ({ children }) => {
  return createPortal(<div id='print-root'>{children}</div>, document.body)
}
